import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Phone, Mail } from "lucide-react";
import SEO from "@/components/SEO";
import { ShieldWm } from "@/components/Watermark";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { FadeUp, MaskedLine, Eyebrow, ParallaxImg } from "@/components/Reveal";

const KHALID_IMG = "https://customer-assets-7cd3h4nn.emergentagent.net/job_elite-transfer-italy/artifacts/mzv0f68v_IMG-20260521-WA0041%281%29.jpg";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContattiEn() {
  const [contatti, setContatti] = useState({ configurato: true, email: "info@zaichauffeur.it", telefono: "+39 3208189469", whatsapp_link: true });

  useEffect(() => {
    axios.get(`${API}/contatti`).then((res) => setContatti(res.data)).catch(() => {});
  }, []);

  const telefono = contatti?.telefono || null;
  const waLink = contatti?.whatsapp_link || null;

  return (
    <>
      <SEO
        title="Contacts | Zaichauffer – Private Chauffeur Italy"
        description="Contact Zaichauffer for information on a private chauffeur service: airport, business and event transfers in Milan, Lombardy, Emilia-Romagna and throughout Italy."
      />
      <section className="relative isolate mx-auto max-w-7xl overflow-hidden px-6 pb-20 pt-40 md:pb-28 md:pt-52" data-testid="contatti-hero">
      <ShieldWm className="-z-10 -right-24 top-10 w-[400px] opacity-[0.04]" />
        <FadeUp><Eyebrow>Contacts</Eyebrow></FadeUp>
        <h1 className="mt-10 max-w-4xl font-serif text-4xl leading-[1.08] tracking-tight text-bone sm:text-5xl lg:text-6xl">
          <MaskedLine>LET'S TALK ABOUT YOUR NEXT JOURNEY.</MaskedLine>
        </h1>
        <FadeUp delay={0.2}>
          <p className="mt-8 max-w-xl text-[15px] font-light leading-relaxed text-mute">
            For information, availability or personalised requests, you can contact Zaichauffer
            directly.
          </p>
        </FadeUp>
      </section>

      <section className="mx-auto max-w-7xl px-6 pb-24 md:pb-36" data-testid="contatti-details">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <FadeUp>
              <div className="border border-white/10 bg-coal p-10 md:p-14">
                <p className="label-cap">The owner</p>
                <p className="mt-4 font-serif text-3xl text-bone">Khalid El Aissaoui</p>
                <div className="mt-12 space-y-8">
                  <div>
                    <p className="label-cap !text-[9px]">Email</p>
                    <p data-testid="contatti-email-value" className="mt-2 text-[15px] font-light text-bone/85">info@zaichauffeur.it</p>
                  </div>
                  <div>
                    <p className="label-cap !text-[9px]">Phone</p>
                    <p data-testid="contatti-phone-value" className="mt-2 text-[15px] font-light text-bone/85">+39 3208189469</p>
                  </div>
                  <div>
                    <p className="label-cap !text-[9px]">WhatsApp</p>
                    <p data-testid="contatti-whatsapp-value" className="mt-2 text-[15px] font-light text-bone/85">Available</p>
                  </div>
                </div>
                <div className="mt-14 flex flex-col gap-4">
                  {telefono && (
                    <a data-testid="contatti-button-chiama" href={`tel:${telefono.replace(/\s/g, "")}`} className="btn-solid">
                      <Phone size={15} /> Call
                    </a>
                  )}
                  {waLink && (
                    <a data-testid="contatti-button-whatsapp" href={waLink} target="_blank" rel="noopener noreferrer" className="btn-outline btn-wa">
                      <span className="wa-ic"><WhatsAppIcon size={15} /></span> Chat on WhatsApp
                    </a>
                  )}
                  {contatti?.email && (
                    <a data-testid="contatti-button-email" href={`mailto:${contatti.email}`} className="btn-outline">
                      <Mail size={15} /> Send an email
                    </a>
                  )}
                </div>
              </div>
            </FadeUp>
          </div>

          <div className="lg:col-span-6">
            <FadeUp delay={0.15} className="lg:pl-12">
              <div className="frame-gold">
                <ParallaxImg src={KHALID_IMG} alt="Khalid El Aissaoui with the black Zaichauffer vehicle" className="relative z-10 aspect-[4/5] w-full" />
              </div>
              <div className="mt-14 border-l-2 border-gold pl-6">
                <p className="font-serif text-xl italic leading-snug text-bone/90 md:text-2xl">
                  Or simply request a quote: Khalid will receive your request directly by email.
                </p>
                <Link to="/en/get-a-quote" className="lux-link mt-8">Request a quote</Link>
              </div>
            </FadeUp>
          </div>
        </div>
      </section>
    </>
  );
}
